/* @generated */
/* empty css                                      */import "./theme-container.css.ts.vanilla.css.esm.js";
var themeContainer = "dig-1hicw9p1_3-8-0 dig-1hicw9p0_3-8-0 dig-ekabin0_3-8-0";
export {
  themeContainer
};
